








































import Vue from "vue";
import { Select, Option } from "element-ui";
import HttpClientFactory from "../../../services/HttpClientFactory";
import HttpClient from "../../../services/HttpClient";
import PaginationStatus from "../../../types/pagination/PaginationStatus";
interface GetPageSizeApiResponse {
  pageSize: number;
}
export default Vue.extend({
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      pagination: {
        perPage: 0,
        perPageOptions: [5, 10, 25, 50]
      } as PaginationStatus
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.loadPageSize();
  },
  methods: {
    changePageSize(pageSize: number) {
      this.httpClient = HttpClientFactory.getInstance();
      this.httpClient
        .put(process.env.VUE_APP_BACKEND_ENDPOINT + "/settings/v1/page-size", {
          pageSize
        })
        .then(() => {
          return;
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("sender:error"),
            type: "error"
          };
          this.$notify(error);
        });
    },
    async loadPageSize() {
      try {
        const response = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/settings/v1"
        );
        this.pagination.perPage = response.data.pageSize;
      } catch (e) {
        const error: any = {
          text: this.$t("sender:error"),
          type: "error"
        };
        this.$notify(error);
      }
    }
  }
});
